import ProductionScheduleStore from "./ProductionSchedule/ProductionScheduleStore";
import DepartmentProductionScheduleStore from "./DepartmentProductionSchedule/DepartmentProductionScheduleStore";
import ProductionOverviewScheduleStore from "./ProductionOverviewSchedule/ProductionOverviewScheduleStore";
import ScheduleGeneratorStore from "./ScheduleGenerator/ScheduleGenerator.Store";
import ScheduleGeneratorFormStore from "./ScheduleGenerator/ScheduleGeneratorForm.Store";
import StructureCastProductionScheduleStore from "./MillerProductionSchedule/MillerProductionScheduleStore";
import StructureCastJobsClientsStore from "./MillerJobsClients/MillerJobsClientsStore";

const schedulingStoreList = [
    { name: "productionScheduleStore", store: ProductionScheduleStore },
    { name: "departmentProductionScheduleStore", store: DepartmentProductionScheduleStore },
    { name: "productionOverviewScheduleStore", store: ProductionOverviewScheduleStore },
    { name: "scheduleGeneratorStore", store: ScheduleGeneratorStore },
    { name: "scheduleGeneratorFormStore", store: ScheduleGeneratorFormStore },
    { name: "millerProductionScheduleStore", store: StructureCastProductionScheduleStore },
    { name: "millerJobsClientsStore", store: StructureCastJobsClientsStore },
];

export default schedulingStoreList;
